import { createTheme } from "@mui/material/styles";

const PRIMARY = "#06BBC7";

const theme = createTheme({
  palette: {
    primary: {
      main: PRIMARY,
    },
  },

  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },

    MuiFormControl: {
      defaultProps: {
        size: "small",
      },
    },

    MuiSelect: {
      defaultProps: {
        size: "small",
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.9rem",
          color: "rgba(17, 24, 39, 0.62)",

          "&.Mui-focused": {
            color: PRIMARY,
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "14px",
          backgroundColor: "#ffffff",
          fontSize: "0.92rem",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(17, 24, 39, 0.18)",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: PRIMARY,
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: PRIMARY,
            borderWidth: "2px",
          },
        },

        input: {
          paddingTop: "10px",
          paddingBottom: "10px",
        },

        multiline: {
          padding: "10px 14px",
        },
      },
    },
  },
});

export default theme;